import { render, staticRenderFns } from "./mobile_one_stop_trading.vue?vue&type=template&id=7099f1b2&scoped=true&"
import script from "./mobile_one_stop_trading.vue?vue&type=script&lang=js&"
export * from "./mobile_one_stop_trading.vue?vue&type=script&lang=js&"
import style0 from "./mobile_one_stop_trading.vue?vue&type=style&index=0&id=7099f1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099f1b2",
  null
  
)

export default component.exports